import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import Title from './Title';
import { Wrapper, CloseIconWrapper, CloseIcon, Owned } from './styled';
import CopyLink from 'Common/Components/CopyLink';
import CopyApiLink from 'Common/Components/CopyApiLink';
import { selectCurrentWorkspace, selectIsReadOnly } from 'store/Faraday/selectors';
import { redirect } from 'store/Router/actions';
import { selectLocation } from 'store/Router/selectors';
import { FEATURE_SERVICES, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';

const Header = ({ data, owned, serviceId, redirectToService, updateService, entity }) => {
  const dispatch = useDispatch();
  const workspaceSelected = useSelector(selectCurrentWorkspace);
  const intl = useIntl();
  const ownedText = owned ? intl.formatMessage({ id: 'host.hostDetail.owned' }) : intl.formatMessage({ id: 'host.hostDetail.notOwned' });
  const servicePath = `ws/${workspaceSelected}/services/${serviceId}`;
  const readOnly = useSelector(selectIsReadOnly);
  const location = useSelector(selectLocation);
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_SERVICES, PERMISSION_TYPES.UPDATE));
  const canUpdate = (entity === 'serviceDetailGeneral')
    ? allowedByRole
    : !readOnly && allowedByRole;

  const updateOwned = () => {
    if (canUpdate) updateService(serviceId, { owned: !owned });
  };

  const closeDetail = () => {
    const search = get(location, 'search', '');
    const params = new URLSearchParams(search || '');
    const fromExplore = params.get('fromExplore') === '1';
    const returnPath = params.get('return');

    if (fromExplore && returnPath) {
      dispatch(redirect(decodeURIComponent(returnPath)));
      return;
    }

    dispatch(redirectToService());
  };

  useModalShortcuts({ id: 'service-detail', onCancel: closeDetail, cancelLabel: 'Close' });

  return (
    <Wrapper>
      <Title serviceDetail={ data } serviceId={ serviceId } updateService={ updateService } entity={ entity } />
      <Owned owned={ owned } onClick={ updateOwned } disabled={ !canUpdate }>{ ownedText }</Owned>
      <CopyLink />
      <CopyApiLink path={ servicePath } />
      <CloseIconWrapper onClick={ closeDetail }>
        <CloseIcon />
      </CloseIconWrapper>
    </Wrapper>
  );
};

export default Header;
